import Vue from 'vue'
import Index from './index.vue'
import router from '@/router/router'
import store from '@/store/store'
const Constructor = Vue.extend(Index)

let instance = null;
let init = () => {
  Index.install = (data => {
    instance = new Constructor({
      data,
      store
    }).$mount();
    document.body.appendChild(instance.$el);
  })();
};
let detail = opts => {
  init(opts);
  Vue.nextTick(() => {
    instance.open(opts);
  });
};

router.afterEach((to, from) => {
  if(instance) {
    instance.handleClose()
    instance.closeDialog();
    instance.closePro();
  }
})

export default {
  install: Vue => {
    Vue.prototype.$memberdetail = detail
  }
}
